<template>
    <div class="message">
        <Form :model="formItem" :label-width="100">
            <FormItem :label="$t('sms.codeSign')">
                <Input v-model="formItem.mobile_code_sign"></Input>
            </FormItem>
            <FormItem :label="$t('sms.notifySign')">
                <Input v-model="formItem.notify_sign"></Input>
            </FormItem>
            <FormItem>
                <Button type="primary" @click="doPost">{{$t('submit')}}</Button>
                <Button style="margin-left: 8px">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>
    </div>
</template>



<script>

export default {
    data() {
        return {
            formItem: {}
        };
    },
    mounted(){
        this.loadData();
    },
    methods: {
        doPost() {
            this.$post(this.$path.system, this.formItem).then(res => {
                if (res.success) {
                    this.$Message.success('修改成功');
                } else {
                    this.$Message.error('修改失败');
                    console.error(res);
                }
            });
        },
        loadData() {
            this.$get(this.$path.system, {
                
            }).then(res => {
                if (res.data) {
                    this.formItem = res.data;
                } else {
                    this.$Message.error('获取数据失败');
                }
            });
        }
    }
    
};
</script>



<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/system/message.vue